
// 
export const addUserDetails = () => {
	return {
		browser: null, //get browser name
		codeName: navigator.appCodeName,
		ip: "1.1.1.1",
		language: navigator.language,
		location: null,
		name: navigator.appName,
		platform: navigator.platform,
		userAgentHeader:  navigator.userAgent,
		version: navigator.appVersion
	}
}